import { render, staticRenderFns } from "./Wikibase.vue?vue&type=template&id=25cf2084&scoped=true&"
import script from "./Wikibase.vue?vue&type=script&lang=js&"
export * from "./Wikibase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cf2084",
  null
  
)

export default component.exports